<div class="sidenav" id="sidenav">
               
   <p  routerLink="/{{menuItem.id}}" [routerLinkActive]="['inactive', 'active']"
    *ngFor="let menuItem of menuItemlist">
    <span [ngClass]="menuItem.id == '1'? 'hide' : 'show'"><img src="../../../../assets/images/sideMenu/{{menuItem.img}}.svg" alt='menutiem'></span><span style="padding-left:2px;">{{ menuItem.Item }}</span>
</p>

</div> 
